export const convertUrl = (url: string, mode: "full" | "optimized"): string => {
  // Remove the params.
  const pathWithoutQueryParams = url.split("?")[0];
  if (mode === "full") {
    return pathWithoutQueryParams;
  }
  return `${pathWithoutQueryParams}?w=960&fit=max`;
};
